import { OwnerUser } from './user';
import { MediaFile } from '.';
import { VehicleModelMinimal } from './vehicleModal';
import { VehicleVariantMinimal } from './vehicleVariant';
import { Showroom } from './showroom';
import { ConfigurationStatus } from './configuration';

export interface OcrDocuments {
  ocrDocument: MediaFile;
  requestedAt?: Date;
  requestedBy?: OwnerUser;
  status: string;
  tagGroup: string;
  updatedAt?: Date;
  uploadedAt?: Date;
  _id?: string;
  adminApprovedBy?: OwnerUser;
  adminApprovedAt?: Date;
  approvedByType?: string;
  isResubmitted?: boolean;
  resolvedWith?: string[];
  rejections?: { rejectionComments: string }[];
  rejectedAt?: Date;
  rejectedBy?: OwnerUser;
  gcApprovedAt?: Date;
  gcApprovedBy?: OwnerUser;
  documentName?: string;
  rejectedByType?: string;
  isReSubmissionApproved?: boolean;
  isReSubmission?: boolean;
  aiPredictedScore?: number;
}

export interface OcrOrder {
  orderId: string;
  quotationNo: string;
  salesPerson: OwnerUser;
  showroomLocation: Showroom;
}

export interface OcrList {
  _id: string;
  configurationId: string;
  createdAt: string;
  customer?: {
    customerCivilId: string;
    customerFullName: string;
    customerMagicNumber: string;
    email: string;
    phoneNumber: number;
  };
  ocrDocuments?: OcrDocuments[];
  ocrDocumentsStatus?: string;
  order?: OcrOrder;
  updatedAt: Date;
  uploadedAt: Date;
  uploadedBy: OwnerUser;
  vehicle?: OcrVehicle;
  rejections: Rejections[];
  isRejected?: boolean;
  missingDocuments?: string[];
  rejectedByType?: string;
  configurationStatus?: ConfigurationStatus;
}

export interface OcrBatchList {
  _id: string;
  configurationId: string;
  createdAt: string;
  customer?: {
    customerCivilId: string;
    customerFullName: string;
    customerMagicNumber: string;
    email: string;
    phoneNumber: number;
  };
  ocrDocuments?: OcrDocuments[];
  ocrDocumentsStatus?: string;
  order?: OcrOrder;
  updatedAt: Date;
  uploadedAt: Date;
  uploadedBy: OwnerUser;
  vehicle?: OcrVehicle;
  rejections: Rejections[];
  isRejected?: boolean;
  missingDocuments?: string[];
  rejectedByType?: string;
}

export interface S3FileTracker {
  _id: string;
  createdAt: string;
  fileKey: string;
  beingRequestedToAi: boolean;
  isAiRequestSuccess?: boolean;
  aiRequestFailCount: number;
  aiRequestedAt?: Date;
  aiRequestedFailedAt?: Date;
  isAiRequestTimeout?: boolean;
  status: FileTrackerBatchStatus;
  response?: any;
  errorLogs?: any[];
  requestMetaData?: any;
  ocrIds?: string[];
  failedFiles?: any[];
}

export interface OcrVehicle {
  exteriorColorCode: string;
  exteriorColorName: string;
  interiorColorCode: string;
  interiorColorName: string;
  model: VehicleModelMinimal;
  variant: VehicleVariantMinimal;
  vinNumber: string;
  vsbNumber: string;
  xco: string;
}

export interface Rejections {
  createdAt: Date;
  rejectedAt: Date;
  rejectedBy: OwnerUser;
  rejectionComments: string;
  updatedAt: Date;
  _id: string;
}

export interface OcrDocumentTag {
  lowerCaseCode: string;
  name: string;
  accountType: string[];
}

export enum FileTrackerBatchStatus {
  Pending = 'Pending',
  Success = 'Success',
  Failed = 'Failed',
  Timeout = 'Timeout',
}

export enum OcrFileStatus {
  DocumentNotSubmitted = 'DocumentNotSubmitted',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Approved = 'Approved',
  Missing = 'Missing',
}

export enum RejectedByType {
  AdminRejected = 'AdminRejected',
  GCRejected = 'GCRejected',
}

export enum ApprovedByType {
  AdminApproved = 'AdminApproved',
  GCApproved = 'GCApproved',
}

export enum OcrDocumentsStatus {
  Pending = 'Pending',
  AdminReviewRequested = 'AdminReviewRequested',
  GCReviewRequested = 'GCReviewRequested',
  Approved = 'Approved',
}
